// Shared role display metadata for the Access Management tab — keep in sync with the
// tri-state role model in the backend's helpers/accessControl.js.
export const ROLE_META = {
  superadmin: { label: "Super Admin", bg: "#160647", color: "#fff" },
  admin: { label: "Admin", bg: "#FA9905", color: "#fff" },
  user: { label: "User", bg: "#ECEFF1", color: "#160647" },
};
